import { HomeCircleOutlineIcon } from './HomeCircleOutlineIcon';

/**
 * author: Terren
 * id 2AD26260-A0C1-42BE-99A2-889F460EF25D
 * name home-circle-outline
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-circle-outline.svg
 * tags
 * - Home Automation 
 */
export const HouseCircleOutlineIcon = HomeCircleOutlineIcon;
export default HouseCircleOutlineIcon